import React from 'react';
import { FormattedMessage } from 'react-intl';
import SolutionView from '../challenge/SolutionView';
import { hasRole } from '../challenge/indexRoles';
import { ChallengePlaceholder } from './PracticeSection';

// Three worked examples built by the engine with the user's own convention (they replace the former mnemonic):
// the marker framed, the answer highlighted in the challenge, the answer in clear and the "why" of the engine.
const ExamplesSection = ({ examples, blockSizes }) => {
    if (examples.status === 'hidden' || examples.status === 'idle') return null;
    const showMarker = examples.items.some((item) => hasRole(item.solution && item.solution.highlights, 'MARKER'));
    return (
        <section className="hia-ack-card" aria-labelledby="hia-ack-h-examples" data-section="examples">
            <h2 id="hia-ack-h-examples" className="hia-ack-h2"><FormattedMessage id="conventionPage.examples.heading" /></h2>
            {examples.status === 'loading' && (
                <>
                    <ChallengePlaceholder blockSizes={blockSizes} />
                    <p className="hia-ack-note"><FormattedMessage id="conventionPage.examples.loading" /></p>
                </>
            )}
            {examples.status === 'ready' && (
                <>
                    <p className="hia-ack-legend">
                        {showMarker && (
                            <span className="hia-ack-legend-item">
                                <i className="hia-ack-swatch hia-ack-swatch--marker" aria-hidden="true" />
                                <FormattedMessage id="conventionPage.examples.legend.marker" />
                            </span>
                        )}
                        <span className="hia-ack-legend-item">
                            <i className="hia-ack-swatch hia-ack-swatch--answer" aria-hidden="true" />
                            <FormattedMessage id="conventionPage.examples.legend.answer" />
                        </span>
                    </p>
                    <div className="hia-ack-examples">
                        {examples.items.map((item, index) => (
                            <div className="hia-ack-example" key={item.practiceId || index} data-testid="example">
                                <p className="hia-ack-example-label">
                                    <FormattedMessage id="conventionPage.examples.label" values={{ n: index + 1 }} />
                                </p>
                                <SolutionView item={item} solution={item.solution} blockSizes={blockSizes} />
                            </div>
                        ))}
                    </div>
                </>
            )}
        </section>
    );
};

export default ExamplesSection;
